"use strict";

// var AGA = AGA || {};

AGA.log = function (message) {
    if (console && console.log) {
        console.log(message);
    }
};
